import { useMemo } from "react"
import { IntlShape } from "react-intl"
import { EIconStyle } from "../../enums/animationSettings"
import { message } from "../../messages/animationSettings"

export default function useIconStyleSelection(intl: IntlShape) {
    return useMemo(
        () => [
            {
                label: intl.formatMessage(message.backplate),
                value: EIconStyle.Backplate,
            },
            {
                label: intl.formatMessage(message.circle),
                value: EIconStyle.Circle,
            },
            {
                label: intl.formatMessage(message.line),
                value: EIconStyle.Line,
            },
        ],
        [intl],
    )
}
